import React from "react";
import styled from "styled-components";
import {Redirect, Route, Switch} from "react-router-dom";
import {ListWidget} from "./list";

export const ClaimsPage: React.FC = () => {
    return (
        <WapStyle>
            <Switch>

                <Route path="/claims/list" component={ListWidget} />
                <Redirect to="/claims/list" />

            </Switch>

        </WapStyle>
    );
}



const WapStyle = styled.div`
  padding: 30px;
  box-sizing: border-box;
  background-color: #E5E8F5;
  
`
